var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.25.813A.56.56 0 0 1 .813.25h11.25a.56.56 0 0 1 .562.563v2.25a.56.56 0 0 1-.125.353L8.534 8.324v4.864a.563.563 0 0 1-.756.528L4.71 12.591a.56.56 0 0 1-.37-.528V8.324L.375 3.416a.56.56 0 0 1-.125-.353zm13.5 7.875v1.124h-4.5V8.689zm-1.125 3.374H9.25v-1.124h3.375z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
};
export default SvgFilter;